import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

import { createRoute } from 'lib/util';

const SubaccountActionsEdit = ({ subaccount, company, subcompany, t, handleClick = () => {} }) => (
  <Form.Link
    className={'btn btn-outline-primary btn-sm mx-1'}
    to={createRoute(company.id, subcompany.id, `subaccounts/${subaccount.id}/edit`)}
  >
    {t('actions.edit')}
  </Form.Link>
);

export default translate()(SubaccountActionsEdit);



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/components/list/actions/SubaccountsActionsEdit.js